/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Debts_EmptyInputs */

const en_case_debts_empty = /** @type {(inputs: Case_Debts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No debts added.`)
};

const pt_br2_case_debts_empty = /** @type {(inputs: Case_Debts_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum débito adicionado.`)
};

/**
* | output |
* | --- |
* | "No debts added." |
*
* @param {Case_Debts_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_debts_empty = /** @type {((inputs?: Case_Debts_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Debts_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_debts_empty(inputs)
	return pt_br2_case_debts_empty(inputs)
});